import generateDetailsPageLink from '@Modules/admin/archiving/utils/generateDetailsPageLink';
import CustomDrawer from '@Modules/core/components/CustomDrawer';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';

import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CreationDatatableFilterFormMeta from '@Modules/interfaceManagement/visaBase2/containers/tableHandlers/issuer/chargeback/creation/CreationDatatableFilterFormMeta';
import CreationDatatableRowFormMeta from '@Modules/interfaceManagement/visaBase2/containers/tableHandlers/issuer/chargeback/creation/CreationDatatableRowMeta';
import {
  TCreationDatatableData,
  getCreationDatatableColumns
} from '@Modules/interfaceManagement/visaBase2/containers/tableHandlers/issuer/chargeback/creation/CreationDatatableMeta';
import FilterFormUI from '@Shared/components/form/FilterFormUI';
import GenericFormUI from '@Shared/components/form/GenericFormUI';
import { useToast } from '@chakra-ui/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

const initialColumnVisibility: {[x: string]: boolean} = {};

const CreationTableHandler = () => {
  const [rowDatatable, setRowDatatable] =
    React.useState<TCreationDatatableData>({
      primaryKey: '',
      TC: '',
      processingDate: '',  
      acquirerReferenceNumber: '',
      accountNumber: '',
      amount: '',
      currency: '',
      merchant: '',
      usage: '',
      selected: false,
      reasonCode: '',
      message: '',
    });

  const fakeDatatable: TCreationDatatableData[] = [
    {
      primaryKey: 1,
      TC: '',
      processingDate: '',  
      acquirerReferenceNumber: '',
      accountNumber: '',
      amount: '',
      currency: '',
      merchant: '',
      usage: '',
      selected: false,
      reasonCode: '',
      message: '',
    },
    {
      primaryKey: 2,
      TC: '',
      processingDate: '',  
      acquirerReferenceNumber: '',
      accountNumber: '',
      amount: '',
      currency: '',
      merchant: '',
      usage: '',
      selected: false,
      reasonCode: '',
      message: '',
    },
    {
      primaryKey: 3,
      TC: '',
      processingDate: '',  
      acquirerReferenceNumber: '',
      accountNumber: '',
      amount: '',
      currency: '',
      merchant: '',
      usage: '',
      selected: false,
      reasonCode: '',
      message: '',
    },
    
  ];

  const detailsDrawerRef = React.useRef<any>(null);

  const editModalRef = React.useRef<any>(null);

  const formModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null);
  
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['Creation'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve(fakeDatatable), 500);
      });
    },
    refetchInterval: 120000,
    refetchIntervalInBackground: true,
    refetchOnMount: true,
    onSuccess: (data_: TCreationDatatableData[]) => {
      console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const queryClient = useQueryClient();


  // ===============================================================================
  const { mutateAsync, isLoading: isSubmitting } = useMutation({
    mutationFn: async (rowData: TCreationDatatableData) => {
      return await new Promise(function (resolve) {
        setTimeout(() => resolve(rowData), 500);
      });
    },
    onSuccess: (updateRowData: any) => {
      console.log('Response: ', data);

      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error: any) => {
      
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const { mutateAsync: mutateDatatable, isLoading: isSubmittingDatatable } = useMutation({
    mutationFn: async (rowData: TCreationDatatableData) => {
      return await new Promise(function (resolve) {
        setTimeout(() => resolve(rowData), 500);
      });
    },
    onSuccess: (updateRowData: any) => {
      console.log('Response: ', data);

      // Only for the simulation
      const data_ = queryClient.setQueryData<TCreationDatatableData[]>(
        queryKey,
        (data) => {
          return data?.map((rowData) => {
            return updateRowData.primaryKey === rowData.primaryKey
              ? updateRowData
              : rowData;
          });
        }
      );

      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error: any) => {
      
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    try {
      await mutateAsync(payload);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmitTable = async (payload: any) => {
    console.log('payload Table: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    try {
      await mutateDatatable(payload);
    } catch (error) {
      console.log(error);
    }
  };
  
  // ===============================================================================
  
  const displayDetails = (row: any) => {
    // setRowDetails(row.original);
    detailsDrawerRef?.current?.onOpen();
  };

  const navigate = useNavigate();

  const handleEdit = (row: any) => {
    setRowDatatable(row.original);
    editModalRef?.current?.onOpen();
  };
  const handleDetails = (row: any) => {
    // const rootUrl = URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU.ATM_TRANSACTION_INQUIRY_DETAILS
    const rootUrl = '#'
    const page = '';
    setRowDatatable(row.original);
    navigate(generateDetailsPageLink(rootUrl, row.original.primaryKey, page))
  };

  const columns = getCreationDatatableColumns({
    isLoading,
    handleEdit,
    handleDetails,
    displayDetails,
  });

  const triggerSubmit = () => {
    formModalRef?.current?.submitBtnRef?.current?.click();
  };


  const drawerContent =
      (<>
          <CC.SimpleGrid columns={3} spacing={5}>
          
          {columns.map((column, i) => column.enableHiding !== false && column.id !== 'action' &&column.header && <CC.Box key={i}>
              <CC.Heading size='xs' textTransform='uppercase'>
              {column.header as ReactNode}
              </CC.Heading>
              <CC.Text pt='2' fontSize='sm'>              
              {rowDatatable[column.id!]}
              </CC.Text>
          </CC.Box>)}
          </CC.SimpleGrid>

          <CC.Divider my={5} />

          <CC.SimpleGrid columns={3} spacing={5}>
          {columns.map((column, i) => 
              {  
                  initialColumnVisibility[column.id!] = column.enableHiding === false ? false : true;
  
                  return (column.enableHiding === false && column.id !== 'action' && column.header && <CC.Box key={i}>
                      <CC.Heading size='xs' textTransform='uppercase'>
                      {column.header as ReactNode}
                      </CC.Heading>
                      <CC.Text pt='2' fontSize='sm'>
                      {rowDatatable[column.id!]}
                      </CC.Text>
                  </CC.Box>)
              }
          )}
          </CC.SimpleGrid>
      </>);

  return (
    <>
      <FilterFormUI meta={CreationDatatableFilterFormMeta} onSubmit={onSubmit} isSubmitting={isSubmitting} isLoading={isLoading}/>

      <CustomReactTable
        data={data || fakeDatatable.slice(0, 6)}
        initialColumnVisibility={initialColumnVisibility}
        columns={columns}
        hasPagination={false}
      />
      
      <CustomDrawer title='Détails' ref={detailsDrawerRef}>
      {drawerContent}
      </CustomDrawer>


      <CustomAppModal
        title="Editer"
        ref={editModalRef}
        actionBtn={
          <CustomSaveBtn
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            onClick={() => {
              triggerSubmit();
            }}
          />
        }
        isSubmitting={isSubmitting}
        onClose
        actionBtnText={'Valider'}
        size="3xl"
        isCentered
        closeOnOverlayClick={false}
      >
        <GenericFormUI
          data={rowDatatable}
          meta={CreationDatatableRowFormMeta}
          onSubmit={onSubmitTable}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          ref={formModalRef}
        />
      </CustomAppModal>

    </>
  );
};

export default CreationTableHandler;
